<template>
	<div class="rowSections">
		<div class="rowSections-ruler">
			<div class="rowSections-rulerValue">{{ rowWidth }} мм</div>
		</div>
		<div class="rowSections-area" ref="area">
			<div class="rowSections-list">
				<RowSectionItem v-for="(section, i) in sections" :key="i"
					:style="{width: sectionsWidths[i] + 'px'}"
					:svgHeight="svgHeight"
					:number="i"
					:separate="separate"
					:capacity="capacity"
					:height="height"
					:depth="depth"
					:section="section"
					:racksType="racksType"
					@edit="$emit('edit')"
					@update="updateSection(section, $event, i)"
					@remove="removeSection(section, i)"
					@copy="copySection(section, i)"
				></RowSectionItem>
			</div>
			<ShelvingSVG class="rowSections-svg" :scale="scale" :svgScale="svgScale" :height="height" :depth="depth" :sections="sections" :rackWidth="rackWidth" :separate="separate" :row-accessories="accessories"></ShelvingSVG>
		</div>
		<div class="rowSections-fadeLeft" v-if="fadeLeft" @click="scroll(-160)"></div>
		<div class="rowSections-fadeRight" v-if="fadeRight" @click="scroll(160)"></div>
	</div>
</template>

<script>
	import RowSectionItem from './RowSectionItem.vue'
	import ShelvingSVG from './ShelvingSVG.vue'

	export default {
		props: {
			rowWidth: Number,
			capacity: Number,
			separate: Boolean,
			height: Number,
			depth: Number,
			sections: Array,
			rackWidth: {
				type: Number,
				default: 5.6,
			},
			beamsType: String,
			coupler: Boolean,
			accessories: Object
		},
		data() {
			return {
				scale: 0.172,
				svgScale: 1,
				fadeLeft: false,
				fadeRight: false,
			};
		},
		computed: {
			racksType() {
				let racksType = 'Profi'
				this.sections.forEach(section => {
					racksType = section.count >=6 ? 'Expert' : racksType;
				});
				return racksType;
			},
			svgHeight() {
				return (this.height * this.scale + this.depthOffset.y) * this.svgScale;
			},
			depthOffset() {
				return {
					x: this.depth / 10 / 1.8,
					y: this.depth / 10 / 3,
				};
			},
			sectionsWidths() {
				const firstOffset = this.depthOffset.x + this.rackWidth - 1 / this.svgScale;
				return this.sections.map((section, i) => {
					return (section.width * this.scale + this.rackWidth + (i === 0 ? firstOffset : 0)) * this.svgScale;
				});
			},
		},
		watch: {
			sections() {
				this.$nextTick(this.updateFade);
			},
		},
		mounted() {
			this.updateFade();
			this.$refs.area.addEventListener('scroll', this.updateFade);
		},
		methods: {
			updateFade() {
				const scrollLeftMax = this.$refs.area.scrollWidth - this.$refs.area.clientWidth;
				this.fadeLeft = (this.$refs.area.scrollLeft > 0);
				this.fadeRight = (this.$refs.area.scrollLeft < scrollLeftMax);
			},
			scroll(delta) {
				this.$refs.area.scrollLeft += delta;
			},
			updateSection(section, data, sectionIndex) {
				section.width = +data.width;
				section.count = +data.count;
				section.shelvesType = data.shelvesType;
				section.beamsType = data.beamsType;
				section.coupler = data.coupler;
				section.index = sectionIndex;
				this.$emit('updateSection', section)
			},
			copySection(section, i) {
				this.sections.splice(i + 1, 0, {...section});
			},
			removeSection(section, i) {
				this.sections.splice(i, 1);
			},
		},
		components: {
			RowSectionItem,
			ShelvingSVG,
		},
	};
</script>

<style scoped>
	.rowSections {
		position: relative;
		display: flex;
		flex-direction: column;
	}
	.rowSections-ruler {
		margin-bottom: 16px;
		height: 24px;
		border-left: 1px solid #333333;
		border-right: 1px solid #333333;
	}
	.rowSections-rulerValue {
		position: relative;
		bottom: 4px;
		font-size: 14px;
		line-height: 16px;
		text-align: center;
		border-bottom: 1px solid #333333;
	}
	.rowSections-fadeLeft {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		width: 48px;
		background: linear-gradient(to right, #FFFFFF 3.65%, rgba(255, 255, 255, 0) 100%);
		cursor: pointer;
	}
	.rowSections-fadeRight {
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		width: 48px;
		background: linear-gradient(to left, #FFFFFF 3.65%, rgba(255, 255, 255, 0) 100%);
		cursor: pointer;
	}
	.rowSections-fadeLeft::after,
	.rowSections-fadeRight::after {
		content: '';
		display: block;
		position: absolute;
		top: 50%;
		width: 20px;
		height: 20px;
		border: 2px solid #F58214;
		opacity: 1;
	}
	.rowSections-fadeLeft:hover::after,
	.rowSections-fadeRight:hover::after {
		opacity: .8;
	}
	.rowSections-fadeLeft::after {
		left: 0;
		border-style: solid none none solid;
		transform-origin: left top;
		/* transform: rotate(-45deg); */
		transform: matrix(0.7, -1, .7, 1 , 0, 0);
	}
	.rowSections-fadeRight::after {
		right: 0;
		border-style: solid solid none none;
		transform-origin: right top;
		/* transform: rotate(45deg); */
		transform: matrix(0.7, 1, -0.7, 1 , 0, 0);
	}
	.rowSections-area {
		flex-grow: 1;
		overflow: auto;
		position: relative;
		max-width: 600px;
		scroll-behavior: smooth;
	}
	.rowSections-list {
		display: flex;
		height: 100%;
		border-left: 1px solid #DDDDDD;
	}
	.rowSections-svg {
		position: absolute;
		bottom: 0;
	}
</style>